import { RatePlanLoyaltyModel } from 'models';

export const adaptLoyaltyMessage = (loyaltyMessage): RatePlanLoyaltyModel => {
  if (!loyaltyMessage) {
    return null;
  }

  return {
    loyaltyEarnIcon: loyaltyMessage.mark?.id,
    loyaltyEarnMessage: loyaltyMessage.value,
    loyaltyEarnAccessibilityMessage: loyaltyMessage.label,
  };
};

export const getLoyaltyMessage = ratePlan => {
  if (ratePlan.loyaltyMessage && ratePlan.loyaltyMessage.value) {
    return ratePlan.loyaltyMessage;
  }

  return null;
};
